import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './EmployeeLogin.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';

function EmployeeLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_BASE}/employee/login`, { username, password });
      localStorage.setItem('employeeToken', data.token);
      navigate('/employee');
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.error || 'Invalid username or password');
    }
  };

  return (
    <div className="employee-login">
      {loading && (
        <div className="employee-login-overlay" role="status" aria-live="polite" aria-busy="true">
          <div className="employee-login-overlay-card">
            <div className="employee-login-spinner" aria-hidden="true" />
            <p className="employee-login-overlay-text">Signing in…</p>
            <p className="employee-login-overlay-hint">Please wait while we verify your credentials.</p>
          </div>
        </div>
      )}
      <div className="employee-login-container">
        <h2>Portal</h2>
        <p className="employee-login-sub">Sign in with your credentials</p>
        <form onSubmit={handleSubmit} aria-busy={loading}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              disabled={loading}
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? 'Signing in…' : 'Login'}
          </button>
        </form>
        <div className={`employee-login-links${loading ? ' employee-login-links--disabled' : ''}`}>
          <Link
            to="/"
            className="back-link back-link--icon"
            aria-label="Back to Home"
            tabIndex={loading ? -1 : 0}
            aria-disabled={loading}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </Link>
          <Link
            to="/admin/login"
            className="back-link"
            tabIndex={loading ? -1 : 0}
            aria-disabled={loading}
          >
            Are you admin?
          </Link>
        </div>
      </div>
    </div>
  );
}

export default EmployeeLogin;
